/**
 * sl-9qm.6.1: ComponentErrorPlaceholder — Error fallback per component
 *
 * Shown when a ViewComponent throws during render.
 * In builder mode, includes a "Remove" button.
 *
 * SOLID:
 * - S: Only error display (no error recovery logic)
 */
import { createElement, type FC } from 'react';

import type { ViewRenderMode } from '../../types/view-component.types';
import * as styles from './styles.css';

interface ComponentErrorPlaceholderProps {
  componentType: string;
  error: Error;
  mode: ViewRenderMode;
  onRemove?: () => void;
}

export const ComponentErrorPlaceholder: FC<ComponentErrorPlaceholderProps> = ({
  componentType,
  error,
  mode,
  onRemove,
}) => {
  return createElement(
    'div',
    { className: styles.errorPlaceholder, role: 'alert' },
    createElement(
      'span',
      { className: styles.errorTitle },
      `Component Error: ${componentType}`
    ),
    createElement('span', { className: styles.errorMessage }, error.message),
    mode === 'builder' &&
      onRemove &&
      createElement(
        'button',
        { className: styles.errorRemoveButton, onClick: onRemove },
        'Remove Component'
      )
  );
};
